/**
 * @file feedback.schema.ts
 * @description Define o schema Zod para a entidade 'Feedback'.
 * Cada documento representa um único feedback dado por um usuário
 * para um MedicalProvider específico.
 */

import { z } from 'zod';

// --- Main Feedback Schema ---

const FeedbackSchema = z.object({
  // ID do provedor que está sendo avaliado.
  providerId: z.string(),

  // ID do usuário que deu o feedback.
  userId: z.string(),
  
  // Nome do usuário, desnormalizado para exibição.
  userPreferredName: z.string(),
  
  // A nota da avaliação, de 1 a 5.
  rating: z.number().int().min(1).max(5),
  
  // Comentário em texto, opcional.
  comment: z.string().optional(),
  
  // Campos de auditoria.
  createdAt: z.date(),
  updatedAt: z.date(),
  deletedAt: z.date().nullable(),
});


// --- Inferred TypeScript Types ---

type Feedback = z.infer<typeof FeedbackSchema>;


// --- Public Exports ---

export { FeedbackSchema };
export type { Feedback };